<template>
	<ul class="bundles">
		<li v-for="bundle in availableBundles" :key="bundle.netPriceLabel">
			<a href="#" @click.stop.prevent="chooseBundle(bundle)">
				<h3>
					{{bundle.netPriceLabel}}<span class="price-small-note">+VAT</span>
				</h3>
				<p>Boost your {{pluralEntityLabel}} to<br/><em>{{bundle.impressions.toLocaleString()}} people</em></p>
				<div
					class="button gradient sunset large">
					Start Promotion
				</div>
			</a>
		</li>
	</ul>
</template>

<script>
	export default {
		methods : {
			chooseBundle (bundle) {
				this.$emit('input', bundle);
			}
		},
		props: ['bundles', 'chosenEntityCount'],
		computed: {
			availableBundles() {
				return this.bundles.filter((bundle) => {
					return this.chosenEntityCount <= bundle.maxEntitiesAllowed
				})
			},
			pluralEntityLabel() {
				return this.chosenEntityCount > 1 ? 'events' : 'event'
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../../assets/scss/var';

	$bundle-gutter : 5px;
	$width         : 500px; // No wider than this arbitrary value...

	.bundles {
		display    : flex;
		flex-wrap  : wrap;
		list-style : none;
		margin     : auto;
		padding    : $bundle-gutter / 2;

		li {
			box-sizing : border-box;
			flex       : 1;
			padding    : $bundle-gutter / 2;
			min-width  : 225px;

			a {
				background    : $color-white;
				border-radius : 2px;
				color         : $color-ents24-boost-sea-green;
				display       : block;
				padding       : $gap-large;

				&:focus {
					background: $color-ents24-sunset-salmon;
				}
			}

			h3 {
				font-size    : 3.5rem;
				font-weight  : 300;
				line-height  : 4rem;
				margin       : 0px auto $gap-default;
				position     : relative;
			}

			.price-small-note {
				bottom      : 14px; // Match to foot of parent <h3>
				font-size   : 1.25rem;
				line-height : 1;
				position    : absolute; // Absolute so that parent <h3> is properly centered, discounting this <span>'s width'
			}

			em {
				font-size : 1.5rem;
				line-height:1.3em;
			}

			div.button {
				color         : $color-ents24-boost-sea-green;
				font-size     : 1.4rem;
				margin-bottom : $gap-default;
				white-space   : nowrap;

				&:hover {
					color : $color-ents24-boost-sea-green;
				}
			}
		}
	}

	.chosen-entity .dull{
		color: $color-grey-v-light;

	}
	.promo-summary{
		padding : $gap-large;
	}

	.gradient-filled{
		margin: 50px auto 20px auto;
	}

	.dull{
		opacity: 1;
		max-width: 800px;
		margin: 10px auto;
	}

	/* iPads (portrait and landscape) + desktop ----------- */
	@media only screen and (min-device-width : 700px) {
		.bundles {

			li {
				min-width: 275px;

				button {
					font-size : 1.6rem!important; // override buttons.scss large class
				}
			}
		}
	}
</style>
